import { render, staticRenderFns } from "./veStuLiteraryActiveEdit.vue?vue&type=template&id=5b38e2cf&scoped=true"
import script from "./veStuLiteraryActiveEdit.vue?vue&type=script&lang=js"
export * from "./veStuLiteraryActiveEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b38e2cf",
  null
  
)

export default component.exports